"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hero = void 0;
const basic_1 = require("../basic");
exports.hero = (0, basic_1.applyBase)({
    wrap: {
        height: ['185px', '520px', '520px'],
    },
});
//# sourceMappingURL=hero.js.map